export const BubbleMenuDivider = () => (
  <hr className="block w-px h-6 border-none bg-gray-200 rounded mx-1"></hr>
);
